import { useForm } from 'react-hook-form'
import { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import '../styles/swicthcss.css'

import { projectContext, loadingContext, urlValue, unfolder, openAlert, useTranslate } from '../lib'
import SelectCodeModal from './SelectCodeModal'
import SwitchBtn from './common/SwitchBtn'
import ButtonYesNo from './common/ButtonYesNo'
import BoxInfo from './common/BoxInfo'
import { Alerts } from './common/Alerts'
import { InputNesting } from './common/Inputs/Input'
import PlayIcon from '../images/play-icon.svg'
import PauseIcon from '../images/pause-icon.svg'
import { CustomChat } from './CustomChat'
import { SelectNesting } from './common/Inputs/Select'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

export function SettingsOptions({ isModalOpen, closeModal, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [users, setUsers] = useState([{}])
  const [loading, setLoading] = useContext(loadingContext)
  const [nlp_config, setNlp_config] = useState(null);
  const [bot_type, setBot_type] = useState(false);
  const [default_Sentiment, setDefault_Sentiment] = useState(false);
  const [nlp_configName, setNlp_configName] = useState("Upload");
  const [language, setLanguage] = useState(selectedProject.metadata.language);
  const [languageTranscription, setLanguageTranscription] = useState(selectedProject?.metadata?.languageTranscription || 'EN-US');
  const [campaings, setCampaings] = useState([])
  const [subCampaings, setSubCampaings] = useState([])
  const [selectedSubCampaignId, setSelectedSubCampaignId] = useState(null);
  const [alert, setAlert] = useState({ title: '', visible: false })
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const [hold, setHold] = useState(0)
  const timeHoldRef = useRef();
  const timeHoldAmountRef = useRef();
  const sentimentBotRef = useRef();
  const useDefaultSentimentRef = useRef();
  const [radomVoice, setRadomVoice] = useState(false)
  const [voices, setVoices] = useState([])
  const [error, setError] = useState({ name: "" })
  const url_simulationRef = useRef();
  const affectation_time_ref = useRef();
  const percentage_affectation_ref = useRef();
  const [category, setCategory] = useState('outbound');
  const [transcription, setTranscription] = useState(0);
  const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
  const [otherLenguage, setOtherLenguage] = useState(0);
  const [timeHold, setTimeHold] = useState(0);
  const [amountTimeHold, setAmountTimeHold] = useState(0);
  const [modelSentiment, setModelSentiment] = useState('Voice');
  const [channel, setChannel] = useState("voice")
  const [assistedSimulation, setAssistedSimulation] = useState(null);
  const [simulationStatus, setSimulationStatus] = useState(null);
  const [customChats, setCustomChats] = useState([]);
  const [selectedChatOption, setSelectedChatOption] = useState(0);
  const [showCustomChatForm, setShowCustomChatForm] = useState(false);
  const [azureScenario, setAzureScenario] = useState(null);
  const [phrasesList, setPhrasesList] = useState('');
  const minimunCallDurations = useRef();
  const maxUserResponseTime = useRef();
  const bot_respose_time_ref = useRef();
  const Simulation_Step_number_ref = useRef();
  const phrases_list_ref = useRef();
  const minimum_passing_score_ref = useRef();
  const { t } = useTranslate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const roles = {
    1: 'Admin',
    2: 'Manager',
    3: 'Editor',
    4: 'Reader',
  }


  const getUsers = async () => {

    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token


      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/user/users-project/${selectedProject.id}`,
        headers: {
          'access-token': token,
        },
      })

      setUsers(response.data)

      return response;
    } catch (error) {
      console.log(error)

      return error
    }

  }

  useEffect(() => {
    (async () => { await getUsers(); })()

  }, [])

  useEffect(() => {
    (async () => {

      await fetchVoice();
      await fetchCampaing();
      const subCampaingsData = await fetchSubCampaing();
      const projectData = await getProject();
      await fetchCustomChats();

      if (projectData?.data?.sub_campaing_id && subCampaingsData.data.data.length>0) {

        const selectedSubCampaign = subCampaingsData.data.data.find(
          subCampaign => subCampaign.id === parseInt(projectData.data.sub_campaing_id)
        );
        if (selectedSubCampaign) {
          setSelectedSubCampaignId(selectedSubCampaign.id);
          setPhrasesList(convertPhrasesListToString(selectedSubCampaign.phrases_list || ''));
        }
      }

    })()



  }, []);

  useEffect(() => {
    if (subCampaings.length > 0 && selectedSubCampaignId) {
      const selectedSubCampaign = subCampaings.find(
        subCampaign => subCampaign.id === parseInt(selectedSubCampaignId)
      );
      if (selectedSubCampaign) {
        setPhrasesList(convertPhrasesListToString(selectedSubCampaign.phrases_list || ''));
      }
    }
  }, [subCampaings, selectedSubCampaignId]);

  const ChangeModelSentiment = (e) => {
    if (e.target.value === 'Voice') {
      selectedProject.bot_sentiment = 0;
    }
  }

  const saveBotSentimentConfig = function (e) {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

    axios({
      method: 'post',
      url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        bot_sentiment: e.target.value,
      }
    }).then(function (res) {
      // console.log('res', res);
    }).catch(error => {
      console.log('Error to try update bot sentiment: ', error);
    })
  }

  const saveProject = (e) => {
    e.preventDefault();
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    const name = selectedProject.name;
    const campaignIdTemp = (campaingRef.current?.value || 0) == 0 ? selectedProject.campaing : campaingRef.current?.value;
    const subCampaignIdTemp = (subCampaingRef.current?.value || 0) == 0 ? selectedProject.sub_campaing : subCampaingRef.current?.value;

    const exp = /^[A-Za-z0-9-,._'\s]+$/g;
    if (!exp.test(name)) {
      ok = false;
      openAlert('#alert-ac', () => {setAlert({title: t('errors.nameInvalid'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    }

    if ((campaignIdTemp || 0) == 0 || (subCampaignIdTemp || 0) == 0) {
      ok = false;
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.selectCampaignSubcampaign'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    }

    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    if (ok) {
      savePhrasesListSubCampaign();
      const voice = document.querySelector("#voice")?.value || '';
      const dataSend = {
        id: selectedProject.id,
        name: name,
        //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
        nlp: selectedProject.nlp,
        nlp_url: selectedProject.nlp_url,
        metadata: { "description": selectedProject.metadata.description, 
          "language": (language || '') == '' ? selectedProject.metadata.language :  language,
          "languageTranscription": (languageTranscription || '')
        },
        //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
        image: selectedProject.image,
        hold: hold,
        time_hold_amount: timeHoldAmountRef.current?.value || 0,
        time_hold_seconds: timeHoldRef.current?.value || 0,
        use_hold: hold ? 1 : 0,
        url_tp_simulation: url_simulationRef.current?.value,
        simulation_status: simulationStatus,
        campaing: campaignIdTemp,
        sub_campaing: subCampaignIdTemp,
        channel: channel,
        voice: voice,
        random_voice: radomVoice ? 1 : 0,
        use_default_sentiment: useDefaultSentiment,
        otherLenguage: otherLenguage,
        bot_sentiment: sentimentBotRef.current?.value,
        model_sentiment: document.getElementById('model_sentiment').value,
        category: category,
        outbound_call: category === 'outbound' ? 1 : 0,
        transcription: transcription,
        welcome_msg: selectedProject.welcome_msg,
        affectation_time: parseInt(document.getElementById('affectation_time')?.value || 0),
        percentage_affectation: parseFloat(document.getElementById('percentage_affectation')?.value || 0),
        min_call_time: minimunCallDurations.current?.value || 0,
        max_user_response_time: maxUserResponseTime.current?.value || 0,
        bot_response_time: bot_respose_time_ref.current?.value || 1,
        num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
        assisted_simulation: assistedSimulation,
        custom_chat: selectedChatOption,
        azure_scenario: azureScenario,
        gender_bot_avatar: document.getElementById('gender_bot_avatar').value,
        minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
      }
      axios({
        method: 'post',
        url: `${urlValue}/studio/project/update`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          console.log('assistedSimulation', assistedSimulation)
          setSelectedProject({
            ...selectedProject,
            name: name,
            voice_id: voice,
            campaing: campaingRef.current?.value,
            sub_campaing: subCampaingRef.current?.value,
            time_hold_amount: timeHoldAmountRef.current?.value || 0,
            time_hold_seconds: timeHoldRef.current?.value || 0,
            use_hold: hold ? 1 : 0,
            url_tp_simulation: url_simulationRef.current?.value,
            simulation_status: simulationStatus,
            random_voice: radomVoice ? 1 : 0,
            use_default_sentiment: useDefaultSentiment,
            bot_sentiment: sentimentBotRef.current?.value,
            model_sentiment: document.getElementById('model_sentiment').value,
            category: category,
            outbound_call: category === 'outbound' ? 1 : 0,
            transcription: transcription,
            affectation_time: document.getElementById('affectation_time')?.value || 0,
            percentage_affectation: document.getElementById('percentage_affectation')?.value || 0,
            min_call_time: minimunCallDurations.current?.value || 0,
            max_user_response_time: maxUserResponseTime.current?.value || 0,
            bot_respose_time: bot_respose_time_ref.current?.value || 1,
            num_simulation_steps: Simulation_Step_number_ref.current?.value || 1,
            assisted_simulation: assistedSimulation,
            custom_chat: selectedChatOption,
            azure_scenario: azureScenario,
            gender_bot_avatar: document.getElementById('gender_bot_avatar').value,
            minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
          })
          getProject();
          openAlert('#alert-ac', () => { setAlert({ title: t('alerts.settingsSaved'), visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          setLoading(false)
        })
        .catch(function (error) {
          openAlert('#alert-ac', () => {setAlert({title: t('alerts.settingsNotSaved'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
          console.error("error ", error)
        })
    }
  }

  const onChangeStatusSimulation = async () => {
    setSimulationStatus((prev) => prev === 0 ? 1 : 0)
    document.getElementById('url_tp_simulation').value = '';
    document.getElementById('Simulation_Step_number_ref').value = '0';
    setAssistedSimulation(0)
    
  }

  const savePhrasesListSubCampaign = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
  
    // Clean phrases using regex to keep only letters, numbers and spaces
    const cleanPhrase = (phrase) => {
      return phrase.replace(/[^a-zA-Z0-9\s]/g, '').trim();
    };
  
    // Process phrases_list_ref into JSON format
    const phrasesListSend = phrasesList.split(';')
      .map((phrase, index) => ({
        id: index + 1,
        phrase: cleanPhrase(phrase)
      }))
      .filter(item => item.phrase !== '');
  
    const dataSend = {
      id: parseInt(subCampaingRef.current.value),
      phrases_list: phrasesListSend
    };
  
    try {
      const response = await axios({
        method: 'post',
        url: `${urlValue}/studio/project/camp/sub-campaing/phrases-list/update`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      });
  
      if (response.status === 200) {
        console.log('Phrases list updated successfully');
        // Update local state to reflect changes
        const updatedSubCampaings = subCampaings.map(subCamp => {
          if (subCamp.id === parseInt(subCampaingRef.current.value)) {
            return { ...subCamp, phrases_list: phrasesList };
          }
          return subCamp;
        });
        setSubCampaings(updatedSubCampaings);
      }
    } catch (error) {
      console.error('Error updating phrases list:', error);
      openAlert('#alert-ac', () => {
        setAlert({
          title: t('alerts.errorPhrasesList'),
          visible: true,
          error: true
        });
      }, 4000, () => {
        setAlert({ ...alert, visible: false });
      });
    }
  };

  const getProject = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    setLoading(true)
    try {
      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/project/${selectedProject.id}`,
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })

      console.log('response.data.azure_scenario', response.data.azure_scenario)

      setSelectedProject(response.data)
      setLanguage(response.data.metadata.language);
      setLanguageTranscription(response.data.metadata?.languageTranscription || 'EN-US')
      setTimeHold(response.data.TimeSecondHold);
      setAmountTimeHold(response.data.AmountTimeHold);
      setRadomVoice(response.data.random_voice);
      setHold(response.data.useHold);
      setUseDefaultSentiment(response.data.use_default_sentiment || selectedProject.use_default_sentiment)
      setOtherLenguage(response.data.otherLenguage || 0)
      setTranscription(response.data.transcription)
      setCategory(response.data.category)
      setChannel(response.data.channel)
      setCategory(selectedProject.category)
      setTranscription(selectedProject.transcription)
      setTimeHold(selectedProject.TimeSecondHold)
      setAmountTimeHold(selectedProject.AmountTimeHold)
      setModelSentiment(selectedProject.model_sentiment)
      setChannel(selectedProject.channel)

      setAssistedSimulation(response.data.assisted_simulation)
      setSimulationStatus(response.data.simulation_status)
      setAzureScenario(response.data.scenario_id);
      setSelectedChatOption(selectedProject?.custom_chat)

      if (minimum_passing_score_ref.current) {
          minimum_passing_score_ref.current.value = response.data.minimum_passing_score || 70;
      }

      document.getElementById('url_tp_simulation').value = response.data.url_tp_simulation;
      document.getElementById('bot_sentiment').value = response.data.bot_sentiment;
      document.getElementById('model_sentiment').value = response.data.model_sentiment;
      document.getElementById('voice').value = response.data.voice_id;
      document.getElementById('custom_chat').value = response.data.custom_chat;
      document.getElementById('campaign').value = response.data.campaing_id;
      document.getElementById('subcampaign').value = response.data.sub_campaing_id;

      document.getElementById('affectation_time').value = response.data.affectation_time;
      document.getElementById('percentage_affectation').value = response.data.percentage_affectation;
      document.getElementById('hold_time').value = response.data.TimeSecondHold;
      document.getElementById('amount_time_hold').value = response.data.AmountTimeHold;
      minimunCallDurations.current.value = response.data.min_call_time || 0;
      maxUserResponseTime.current.value = response.data.max_user_response_time || 0;
      bot_respose_time_ref.current.value = response.data.bot_response_time;
      Simulation_Step_number_ref.current.value = response.data.num_simulation_steps;
      document.getElementById('gender_bot_avatar').value = response.data.gender_bot_avatar;
      console.log('response.data.minimum_passing_score', response.data.minimum_passing_score)

      setLoading(false)
      return response
    }
    catch (error) {
      console.log("Error GetProject", error)
      setLoading(false)
      return error;
    }

  }

  const changeBotType = e => {
    document.querySelectorAll(".list_bot_type .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setChannel(e.target.value);
  }
  const changeBot = async () => {

    // document.querySelector(".list_call_type .checkbox").forEach(element => element.checked = false);
    setChannel((prev) => prev === "voice" ? "chat" : "voice")
    
  }

  const changeCallType = e => {
    document.querySelectorAll(".list_call_type .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setCategory(e.target.value);
  }

  const changeTranscriptionEnable = e => {
    document.querySelectorAll(".list_transcription_enable .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setTranscription(e.target.value);
  }

  const changeUseDefaultSentiment = e => {
    document.querySelectorAll(".list_use_default_sentiment .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setUseDefaultSentiment(e.target.value);
  }

  const convertPhrasesListToString = (phrasesListJson) => {
    try {
      if (!phrasesListJson) {
        return '';
      }
      const phrasesList = typeof phrasesListJson === 'string' 
        ? JSON.parse(phrasesListJson) 
        : phrasesListJson;
  
      return Array.isArray(phrasesList) 
        ? phrasesList.map(item => item.phrase).join(';')
        : '';
    } catch (error) {
      console.error('Error converting phrases list:', error);
      return ''; 
    }
  };

  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    let language = document.getElementById('language').value.substr(0, 2);
    const project_id = selectedProject.id;

    try {
      const url = `${urlValue}/studio/project/voices/all`;
      
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'language': language,
          'project_id': project_id
        },
      });

      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
      return rest;;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
        setPhrasesList( convertPhrasesListToString( rest.data.data[0].phrases_list || '' ));
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchCustomChats = async () => {
    const predefined = [
      { id: 0, name: 'Standard' },
      { id: 1, name: 'WhatsApp' },
      { id: 2, name: 'Telegram' },
    ];
    
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    const project_id = selectedProject.id;

    try {
      const url = `${urlValue}/studio/project/customchats/all`;
      
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'project_id': project_id
        },
      });

      if (rest.status === 200 && rest.data.data) {
        setCustomChats([... predefined, ...rest.data.data])
      }
      return rest.data.data;
    } catch (error) {
      setCustomChats(predefined)
      console.log(error)
      return error;
    }
  };

  const playAnswer = async ()=>{
    let voice = document.getElementById('voice').value;
    let rate = '0.00';
    let pitch = '0';
    let volume = '+100';
    let style = 'Friendly';
    
    const resToke = await axios.post(`https://eastus.api.cognitive.microsoft.com/sts/v1.0/issuetoken`, {}, {
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY
      }
    })
    let token = resToke.data;
    let speaker = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" 
          xmlns:mstts="https://www.w3.org/2001/mstts" xml:lang="en-US">
        <voice name="${voice?.trim()?.replaceAll('_', '-')}">
            <prosody rate="${rate}" pitch="${pitch}" volume="${volume}">
                <mstts:express-as style="${style}">
                    This is a test voice
                </mstts:express-as>
            </prosody>
        </voice>
      </speak>`

      try {
        const res3 = await fetch('https://eastus.tts.speech.microsoft.com/cognitiveservices/v1', {
          method: 'POST',
          headers: {
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_AZURE_SUBCRIPTION_KEY,
            Authorization: `Bearer ${token}`,
            'cache-control': 'no-cache',
            'X-Microsoft-OutputFormat': 'riff-8khz-8bit-mono-alaw',
            'Content-Type': 'application/ssml+xml'
          },
          body: speaker
        });
        if (!res3.ok) {
          throw new Error('Fetch failed!');
        }
        const wavFile = await res3.blob();
        document.querySelector('#audioID').src = URL.createObjectURL(wavFile);
        document.querySelector('#audioID').play();
      } catch (error) {
        console.log(error)
      }

  }

  const stopAnswer = ()=>{

  }


  return (
    <>
      <form onSubmit={saveProject} className="settings-container pt-2 pb-5 " style={{ backgroundColor: '#F9F9F9', paddingRight: 17, borderRadius: 25 }}>
        <div className="scroll-internal ">
          <h2 className="pl-3" style={{ color: '#1C6FB0', fontSize: 16, marginBottom: 15, fontWeight: 'bold' }}>
            {t('menu.generalProjectSettings')}
          </h2>
          <div className="pl-3 d-flex flex-row">
            <div className="d-flex flex-column" style={{ width: '50%' }}>
              

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="d-flex flex-row align-items-center">
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 95}}>
                    <span>{t('menu.genai.botType')}:</span>
                    <img id="bot-type-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#bot-type-tooltip" 
                      html={t('menu.genai.botTypeTooltip')} place="top" />   
                  </div>

                  <div className="ml-2 list_bot_type d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => changeBot()}
                      width={170}
                      state={channel === "chat" ? false : true}
                      height={30}
                      Yes={t('menu.voiceBot')}
                      No={t('menu.chatBot')}
                    />
                  </div>
                </div>
              </div>

              <div className={`${channel==='chat' ? 'hidden': ''} inputs`} style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center">

                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 140}}>
                    <span>{t('menu.genai.interactionType')}:</span>
                    <img id="interaction-type-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#interaction-type-tooltip" 
                      html={t('menu.genai.interactionTimeTooltip')} place="top" />
                  </div>

                  <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                      width={170}
                      state={category === "outbound" ? false : true}
                      height={30}
                      Yes={t('common.inbound')}
                      No={t('common.outbound')}
                    />
                  </div>
                </div>
              </div>
              {channel === 'voice' &&  
                <div className={`inputs`} style={{ marginTop: 20 }}>
                  <div className="input d-flex flex-row align-items-center">

                    <div className="input d-flex flex-row align-items-center" style={{minWidth: 170}}>
                      <span>{t('menu.genai.transcriptionEnable')}:</span>
                      <img id="transcription-enable-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#transcription-enable-tooltip" 
                        html={t('menu.genai.transcriptionEnableTooltip')} place="top" />
                    </div>

                    <div className="list_transcription_enable ml-2 d-flex flex-row align-items-center">
                      <ButtonYesNo
                        onClick={() => setTranscription((prev) => prev === 0 ? 1 : 0)}
                        width={140}
                        state={transcription === 0 ? false : true}
                        height={30}
                      />
                    </div>
                  </div>
                </div>
              }

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center">
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 180}}>
                    <span>{t('menu.defaultForSentiment')}:</span>
                    <img id="default-sentiment-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#default-sentiment-tooltip" 
                      html={t('menu.defaultForSentimentTooltip')} place="top" />
                  </div>
                  <div className="list_use_default_sentiment ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setUseDefaultSentiment((prev) => prev === 0 ? 1 : 0)}
                      width={140}
                      state={useDefaultSentiment === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20, maxWidth: 200 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 95}}>
                    <span>{t('common.language')}:</span>
                    <img id="language-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#language-tooltip" 
                      html={t('menu.genai.languageForProjectTooltip')} place="top" />
                  </div>
                    <div className="select" style={{ flexGrow: '2' }}>
                      <select id="language" className='ml-3 w-100 select-nesting' value={language} onChange={(e) => { setLanguage(e.target.value); }}
                        style={{ flexGrow: '2', fontSize: 14, backgroundPositionX: "98%" }}>
                        <option value="EN-US">{t('common.english')}</option>
                        <option value="ES-CO">{t('common.spanish')}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20, maxWidth: 200 }}>
                <div className="input d-flex flex-row align-items-center">
                  <span>{t('menu.genai.useLanguageDiferent')}:</span>
                  <div className="list_use_default_sentiment ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setOtherLenguage((prev) => prev === 0 ? 1 : 0)}
                      width={140}
                      state={otherLenguage === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
                {otherLenguage == 1 && 
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span className="mr-2">{t('common.language')} {t('testconnection.transcription')}:</span>
                    <div className="select" style={{ flexGrow: '2' }}>
                      <select id="languageTranscription" className='ml-3 w-100 select-nesting' value={languageTranscription} onChange={(e) => { setLanguageTranscription(e.target.value); }}
                        style={{ flexGrow: '2', fontSize: 14, backgroundPositionX: "98%" }}>
                        <option value="EN-US">{t('common.english')}</option>
                        <option value="ES-CO">{t('common.spanish')}</option>
                      </select>
                    </div>
                  </div>
                </div>}
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 95}}>
                    <span>{t('common.campaign')}:</span>
                    <img id="campaign-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#campaign-tooltip" 
                      html={t('menu.genai.campaignTooltip')}  place="top" />
                  </div>
                    <div className="select" style={{ flexGrow: '2' }}>
                      <select id="campaign" ref={campaingRef} className='ml-3 w-100 select-nesting'
                        style={{ flexGrow: '2', fontSize: 14, backgroundPositionX: "98%" }}>
                        {campaings.map((item, i) => (
                          <option value={item.id} key={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 130}}>
                    <span>{t('common.subCampaign')}:</span>
                    <img id="subcampaign-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#subcampaign-tooltip" 
                      html={t('menu.genai.subcampaignTooltip')}  place="top" />
                  </div>
                    <div className="select" style={{ flexGrow: '2' }}>
                      <select id="subcampaign" ref={subCampaingRef} className='ml-3 w-100 select-nesting'
                        onChange={(e) => {
                          setSelectedSubCampaignId(e.target.value);
                        }}
                        style={{ flexGrow: '2', fontSize: 14, backgroundPositionX: "98%" }}>
                        {subCampaings.map((item, i) => (
                          <option value={item.id} key={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {channel === 'voice' &&
                <div className='d-flex flex-column'>
                  <BoxInfo
                    id="phraseslist"
                    titleClass='w-100'
                    title={`${t('menu.genai.phrasesList')}`} 
                    place="top"
                    containerClass='mr-0-5 mt-4'
                    content={t('menu.genai.phrasesListTooltip')} 
                  />
                  <div className="flex flex-col gap-4 mt-3">
                    <div className="flex items-center gap-2">
                      <input
                        type="text"
                        className="flex-1 input-data"
                        placeholder={t('menu.genai.typePhraseEnter')} 
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && e.target.value.trim()) {
                            e.preventDefault();
                            const currentPhrases = phrases_list_ref.current.value
                              ? phrases_list_ref.current.value.split(';').filter(p => p.trim())
                              : [];
                            const newPhrase = e.target.value.trim();
                            if (!currentPhrases.includes(newPhrase)) {
                              const updatedPhrases = [...currentPhrases, newPhrase];
                              phrases_list_ref.current.value = updatedPhrases.join(';');
                              console.log("ref current", phrases_list_ref.current.value)
                              setPhrasesList(updatedPhrases.join(';'));
                            }
                            e.target.value = '';
                          }
                        }}
                      />
                    </div>
                    
                    <div className="flex flex-wrap gap-3 mb-4">
                      {phrasesList.split(';')
                        .filter(phrase => phrase.trim())
                        .map((phrase, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-2 px-4 py-2 rounded-full shadow-sm"
                            style={{
                              borderWidth: '2px', 
                              padding: '5px',
                              margin: '5px',
                              borderColor: '#0087ff',
                              borderRadius: '50px'
                            }}
                          >
                            <span className="text-gray-700">{phrase}</span>
                            <button
                              type="button"
                              onClick={() => {
                                const currentPhrases = phrasesList.split(';').filter(p => p.trim());
                                const updatedPhrases = currentPhrases.filter((_, i) => i !== index);
                                //phrases_list_ref.current.value = updatedPhrases.join(';');
                                setPhrasesList(updatedPhrases.join(';'));
                              }}
                              className="p-1 hover:text-red-500 transition-colors duration-200"
                              style={{ marginLeft: '2px' }}
                            >
                              <img 
                                src="/icons/trash-1.png" 
                                alt="delete" 
                                style={{ width: 16, height: 16 }} 
                              />
                            </button>
                          </div>
                        ))}
                    </div>

                    <input
                      type="hidden"
                      ref={phrases_list_ref}
                      defaultValue={phrasesList}
                    />
                  </div>
                </div>
              }
              {channel === 'chat' &&  
                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input d-flex items-center" style={{ height: "auto" }}>
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 135}}>
                    <span>{t('menu.genai.resolutionTime')}:</span>
                    <img id="resolution-time-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#resolution-time-tooltip" 
                      html={t('menu.genai.resolutionTimeTooltip')} place="top" />
                  </div>
                    <input {...register('affectation_time', { required: false })}
                      ref={affectation_time_ref} defaultValue={selectedProject.affectation_time} id="affectation_time"
                      type="text" className="input-text" style={{maxWidth: 100}} />
                  </div>
                </div>
              }
              {channel === 'chat' &&  
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex items-center " style={{ height: "auto" }}>
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 210}}>
                    <span>{t('menu.genai.percentageOfAffectation')}:</span>
                    <img id="percentage-affectation-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#percentage-affectation-tooltip" 
                      html={t('menu.genai.percentageOfAffectationTooltip')} place="top" />
                  </div>
                  <input {...register('percentage_affectation', { required: false })}
                    ref={percentage_affectation_ref} defaultValue={selectedProject.percentage_affectation} id="percentage_affectation"
                    type="text" className="input-text" style={{maxWidth: 100}} />
                </div>
              </div>
              }

              {channel === 'chat' &&  
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex items-center" style={{ height: "auto" }}>
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 110}}>
                    <span>{t('menu.genai.replyTime')}:</span>
                    <img id="reply-time-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#reply-time-tooltip" 
                      html={t('menu.genai.replyTimeTooltip')} place="top" />
                  </div>
                  <input {...register('reply_time', { required: false })}
                    ref={bot_respose_time_ref}   id="bot_respose_time" style={{maxWidth: 100}}
                    type="text" className="input-text  " />
                </div>
              </div>
              }

              <div className="d-flex flex-column" style={{margin: '30px 0 0 0', borderTop: '1px solid rgb(172 172 172)', padding: '15px 0 0 0'}}>
                <div className='d-flex flex-row align-items-center' style={{alignItems: 'center'}}>
                  
                  <div className="input d-flex flex-row align-items-center" style={{minWidth: 160}}>
                    <h2 className="" style={{ color: '#1C6FB0', fontSize: 16, fontWeight: 'bold' }}>
                      {t('menu.genai.simulationStatus')}
                    </h2>
                    <img id="simulation-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#simulation-tooltip" 
                      html={t('menu.genai.simulationStatusTooltip')} place="top" />
                  </div>
                  <div style={{margin: '0 0 0 10px'}}>
                    <ButtonYesNo
                      onClick={() => onChangeStatusSimulation()}
                      width={150}
                      state={simulationStatus === 0 || simulationStatus === null ? false : simulationStatus}
                      height={30}
                      Yes={t('common.yes')}
                      No={t('common.no')}
                    />
                  </div>
                </div>
                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input d-flex flex-column" style={{ height: "auto" }}>
                    <div className="input d-flex flex-row align-items-center" style={{minWidth: 130}}>
                      <span>{t('menu.genai.urlSimulation')}:</span>
                      <img id="url-simulation-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#url-simulation-tooltip" 
                        html={t('menu.genai.urlSimulationPlaceholder')}  place="top" />
                    </div>
                    <input {...register('url_tp_simulation', { required: false })} disabled={!simulationStatus}
                      ref={url_simulationRef} defaultValue={selectedProject.url_tp_simulation} id="url_tp_simulation"
                      type="text" className={`input-text mt-3 ${!simulationStatus ? 'disabled' : ''}`} />
                  </div>
                </div>

                <div className="inputs" style={{ marginTop: 10 }}>
                  <div className="input d-flex items-center " style={{ height: "auto" }}>
                    <div className="input d-flex flex-row align-items-center" style={{minWidth: 205}}>
                      <span>{t('menu.genai.simulationStepNumber')}:</span>
                      <img id="simulation-step-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#simulation-step-tooltip" 
                        html={t('menu.genai.simulationStepNumberTooltip')} place="top" />
                    </div>
                    <input {...register('num_simulation_steps', { required: false })} disabled={!simulationStatus}
                      ref={Simulation_Step_number_ref}   id="Simulation_Step_number_ref" style={{maxWidth: 90}}
                      type="text" className={`input-text ${!simulationStatus ? 'disabled' : ''}`}
                      />
                  </div>
                </div>

                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input d-flex flex-row align-items-center">
                    <div className="input d-flex flex-row align-items-center" style={{minWidth: 160}}>
                      <span>{t('menu.genai.assistedSimulation')}:</span>
                      <img id="assisted-simulation-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#assisted-simulation-tooltip" 
                        html={t('menu.genai.assistedSimulationTooltip')} place="top" />
                    </div>
                    <div className="ml-2 list_bot_type d-flex flex-row align-items-center">
                      <ButtonYesNo
                        onClick={() => setAssistedSimulation((prev) => prev === 0 ? 1 : 0)}
                        width={150}
                        state={assistedSimulation}
                        height={30}
                        Yes={t('common.yes')}
                        No={t('common.no')}
                        disabled={!simulationStatus}
                      />
                    </div>
                  </div>
                </div>

                {/*<div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input d-flex flex-row align-items-center">
                    <div className="input d-flex flex-row align-items-center" style={{minWidth: 130}}>
                      <span>Azure Scenario:</span>
                      <img id="azure-scenario-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#azure-scenario-tooltip" 
                        html={`Enable Microsoft Azure services<br>integration for enhanced capabilities`} place="top" />
                    </div>
                    <div className="ml-2 list_bot_type d-flex flex-row align-items-center">
                      <ButtonYesNo
                        onClick={() => setAzureScenario((prev) => prev === 0 ? 1 : 0)}
                        width={150}
                        state={azureScenario}
                        height={30}
                        Yes='Yes'
                        No='No'
                      />
                    </div>
                  </div>
                </div>*/}

                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input">
                    <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                      <SelectNesting
                        id="minimum_passing_score" ref={minimum_passing_score_ref}
                        boxInfo={true} tooltipText="" style={{minWidth: 100, whiteSpace: 'nowrap'}}
                        title={`${t('menu.genai.minimumPassingScore')}:`} containerClass="mr-2"
                      >
                        {Array.from({ length: 100 }, (_, i) => i + 1).map((num) => (
                          <option key={num} value={num} selected={num === minimum_passing_score_ref.current?.value}>
                            {num}
                          </option>
                        ))}
                      </SelectNesting>
                    </div>
                  </div>
                </div>

              </div>  

            </div>

            <div style={{ borderRight: '1px solid #bfbfbf', paddingLeft: 16, marginRight: 16 }} />

            <div className="d-flex flex-column pr-3" style={{ width: '35%' }}>

              <div className={`${channel==='chat' ? 'hidden': ''} flex flex-column `}  >
                {channel === 'voice' &&  
                  <div className='flex flex-column'>
                    <div className="input d-flex flex-row align-items-center" style={{minWidth: 260}}>
                      <span>{t('menu.genai.minimunCallDurations')}:</span>
                      <img id="min-call-duration-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#min-call-duration-tooltip" 
                        html={t('menu.genai.minimunCallDurationsTooltip')} place="top" />
                    </div>
                    <input
                      ref={minimunCallDurations}
                      className='mt-3 input-text'
                      disabled={!hold} style={{maxWidth: 100}}
                      type="number" title={`${t('menu.genai.minimunCallDurations')}:`}
                      defaultValue={timeHold}
                      id="minimunCallDurations"
                    />
                  </div>
                }
                {channel === 'chat' &&  
                  <InputNesting
                    containerClass="mr-2"
                    ref={maxUserResponseTime} id="maxUserResponseTime"
                    type="number"
                    title={`${t('menu.genai.maximunCallDurations')}:`}
                  />
                }

              </div>
              <div className="inputs">
                {/* <div className="input">
                  <div className='d-flex flex-row align-items-center w-100'>
                    <label htmlFor="use_hold">{t('menu.genai.onHoldAvailability')}:</label>
                    <input
                      id="use_hold"
                      defaultChecked={hold}
                      onChange={(e) => { setHold(!hold); }}
                      type="checkbox"
                      style={{ marginLeft: 10, width: 'auto' }}
                    />
                  </div>
                </div>  */}
                {channel === 'voice' &&  
                  <div className={`input`} >
                    <div className='d-flex flex-col mt-5  w-100'>
                      <div className="input d-flex flex-row align-items-center" style={{minWidth: 180, marginBottom: 10}}>
                        <span>{t('menu.genai.onHoldAvailability')}:</span>
                        <img id="on-hold-availability-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#on-hold-availability-tooltip" 
                          html={t('menu.genai.onHoldAvailabilityTooltip')} place="top" />
                      </div>
                      <ButtonYesNo
                        onClick={() => setHold((prev) => !prev)}
                        width={140}
                        state={hold}
                        height={30}
                      />
                    </div>
                  </div>
                }
              </div>
              
              {channel === 'voice' &&  
                <div className={`${channel==='chat' ? 'hidden': ''} input`} style={{ marginTop: 25 }}>
                  <div className="input">
                    <div className='d-flex flex-column'>
                      <div className="input d-flex flex-row align-items-center" style={{minWidth: 210}}>
                        <span>{t('menu.genai.holdAttempts')}:</span>
                        <img id="hold-attempts-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#hold-attempts-tooltip" 
                          html={t('menu.genai.holdAttemptsTooltip')} place="top" />
                      </div>
                      <div className="d-flex flex-row align-items-center mt-3">
                        <input style={{ maxWidth: 113 }}
                          ref={timeHoldAmountRef}
                          className='input-text'
                          disabled={!hold}
                          type="number"
                          defaultValue={amountTimeHold}
                          id="amount_time_hold"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              }

              {channel === 'voice' &&  
                <div className={`input`} style={{ marginTop: 25 }}>
                  <div className="input">
                    <div className='d-flex flex-column'>
                      <div className="input d-flex flex-row align-items-center" style={{minWidth: 140}}>
                        <span>{t('menu.genai.holdTime')}:</span>
                        <img id="hold-time-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#hold-time-tooltip" 
                          html={t('menu.genai.holdTimeTooltip')} place="top" />
                      </div>
                      <input
                        ref={timeHoldRef}
                        className='mt-3 input-text'
                        disabled={!hold} style={{maxWidth: 100}}
                        type="number"
                        defaultValue={timeHold}
                        id="hold_time"
                      />
                    </div>
                  </div>
                </div>
              }

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-column">
                    <BoxInfo
                      id="botSentiment-tp"
                      titleClass='mr-0-4 color-label f-16  title-intent'
                      title={`${t('menu.genai.botSentiment')}:`}
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={t('menu.genai.botSentimentTooltip')}
                    />
                    <div className="select" style={{ maxWidth: 93, marginTop: 5 }}>
                      <select id="bot_sentiment" onChange={saveBotSentimentConfig} ref={sentimentBotRef} className="w-100 select-nesting" style={{ backgroundPositionX: "98%" }}>
                        <option value="1" selected={selectedProject.bot_sentiment !== 0 ? 'selected' : ''}>{t('common.on')}</option>
                        <option value="0" selected={selectedProject.bot_sentiment === 0 ? 'selected' : ''}>{t('common.off')}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-column">
                    <BoxInfo
                      id="ModelSentiment-tp"
                      titleClass='mr-0-4 color-label f-16  title-intent'
                      title={`${t('menu.genai.modelSentiment')}:`}
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={t('menu.genai.modelSentimentTooltip')}
                    />
                    <div className="select" style={{ maxWidth: 100, marginTop: 5, }}>
                      <select id="model_sentiment" className="w-100 select-nesting" style={{ backgroundPositionX: "98%" }}>
                        <option value="Phrase">{t('common.phrase')}</option>
                        <option value="Voice">{t('common.voice')}</option>
                        <option value="Answer">{t('common.answer')}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-column">
                    <BoxInfo
                      id="gender_bot_avatar-tp"
                      titleClass='mr-0-4 color-label f-16 title-intent'
                      title={`${t('menu.genderAvatar')}:`}
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={t('menu.genderAvatarTooltip')}
                    />
                    <div className="select" style={{ maxWidth: 100, marginTop: 5, }}>
                      <select id="gender_bot_avatar" className="w-100 select-nesting" style={{ backgroundPositionX: "98%" }}>
                        <option value="male" selected={selectedProject.gender_bot_avatar === 'male' ? true : false}>{t('common.male')}</option>
                        <option value="female" selected={selectedProject.gender_bot_avatar === 'female' ? true : false}>{t('common.female')}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {channel === 'voice' &&  
                <div className={`input`} style={{ marginTop: 25 }}>
                  <div className="input">
                    <div className='d-flex flex-col  w-100'>
                      <div className="input d-flex flex-row align-items-center" style={{minWidth: 150, marginBottom: 10}}>
                        <span>{t('menu.genai.randomVoices')}:</span>
                        <img id="random-voices-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#random-voices-tooltip" 
                          html={t('menu.genai.randomVoicesTooltip')} place="top" />
                      </div>
                      <ButtonYesNo
                        onClick={() => setRadomVoice((prev) => !prev)}
                        width={140}
                        state={radomVoice}
                        height={30}
                      />
                    </div>
                  </div>
                </div>
              }

              {channel === 'voice' &&  
                <div className="inputs" style={{ marginTop: 25 }}>
                  <div className="input">
                    <div className="d-flex flex-column">
                      <div className="input d-flex flex-row align-items-center" style={{minWidth: 110}}>
                        <span>{t('menu.genai.selectVoice')}:</span>
                        <img id="select-voice-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#select-voice-tooltip" 
                          html={t('menu.genai.selectVoiceTooltip')} place="top" />
                      </div>
                      <div className="select" style={{ maxWidth: 220, marginTop: 5 }}>
                        <select className='w-100 select-nesting' style={{ flexGrow: '2', backgroundPositionX: "98%" }} id="voice">
                          {voices.map((item, index) => (
                            <option key={index} value={item.id}>{item.voice}</option>
                          ))}
                        </select>
                      </div>
                      {/*
                      <div className='d-flex align-items-center mt-5'>
                          <a href="#" id='play_audio' onClick={() => { playAnswer() }}>
                            <img src={PlayIcon} alt="" width={12} />
                          </a>
                          <a href="#" id='pause_audio' onClick={() => { stopAnswer() }} style={{marginLeft: 10}}>
                            <img src={PauseIcon} alt="" width={12} />
                          </a>
                      </div>
                      <div style={{marginLeft: 10}}>
                        <audio id="audioID" controls>
                          <source type="audio/mpeg" />
                        </audio>
                      </div>
                      */}
                    </div>
                  </div>
                </div>
              }

              <div className={`${channel==='voice' ? 'hidden': ''} input`} style={{ marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-column">
                    <div className="input d-flex flex-row align-items-center" style={{minWidth: 150}}>
                      <span>{t('menu.genai.customChat')}:</span>
                      <img id="custom-chat-tooltip" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting ml-3" alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#custom-chat-tooltip" 
                        html={t('menu.genai.customChatTooltip')} place="top" />
                    </div>
                    <div className="select" style={{ maxWidth: 183, marginTop: 5 }}>
                    <select
                      className='w-100 select-nesting'
                      style={{ flexGrow: '2', backgroundPositionX: "98%" }}
                      id="custom_chat"
                      onChange={(e) => {
                        const value = e.target.value;
                        console.log(value)
                        setSelectedChatOption(value === 'new' || value === '' ? '' : value);
                        setShowCustomChatForm(value === 'new');
                      }}
                    >
                      {
                        customChats.map((item, index) => (
                          <option value={item.id} key={item.id}>{item.name}</option>
                        )
                      )}
                      <option value="new">{t('common.new')}</option>
                    </select>
                    </div>
                  </div>
                </div>
              
                {showCustomChatForm && (
                <CustomChat
                update={() => { fetchCustomChats() }}
                />
                )}
              
              </div>


            </div>
          </div>

          <div className='cont-buttons mt-5 w-100'>
            <div className="buttons d-flex flex-row justify-end pr-3">
              <button className="create btn-primary btn-bottom btn-bottom-create" type="submit" style={{ backgroundColor: "#0087FF" }}>
                {t('common.save')}
              </button>
            </div>
          </div>
        </div>
      </form>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
      

    </>
  )
}
